import React, { useState } from "react";
import { SearchInputWrapper } from "../../../../../components/common/datatable/filter/SearchInputWrapper";
import { SearchSelectWithList } from "../../../../../components/common/datatable/filter/SearchSelectWrapper";
import { formatValueAsDate } from "../../../../../helpers/utils/DateUtils";
import { DataTable } from "../../../../../components/common/datatable/DataTable";
import { DataTableColumn } from "../../../../../components/common/datatable/DataTableTypes";
import Modal from "../../../../../components/common/form/Modal";
import { isDuplicateAccountExist } from "../../../../../helpers/utils/OrderDetailUtils";
import { trimSpace } from "../../../../../helpers/utils/Utils";
import { useClonedAccountsQuery } from "../../../productsApi";
import ButtonTray from "../../../../../components/common/form/ButtonTray";

interface CloneAccountsModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    tenant: string;
    isHoaEditor: boolean;
    orderId: string;
    countyData: any;
    existingProperty: any[];
    setSelectedCloneAccountList: (list: any[]) => void;
    customerOrderNumber: string | null;
    setCustomerOrderNumber: any;
    state: string;
}

export function CloneAccountsModal({
    show,
    setShow,
    tenant,
    isHoaEditor,
    orderId,
    countyData,
    existingProperty,
    setSelectedCloneAccountList,
    customerOrderNumber,
    setCustomerOrderNumber,
    state
}: CloneAccountsModalProps): JSX.Element {

  
    const [selectedAccountList, setSelectedAccountList] = useState<any[]>([]);
    const [date, setDate] = useState<string>("");
    const [isCountySelected, setIsCountySelected] = useState(true);


    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        if (selectedAccountList.length > 0) {
            setCustomerOrderNumber(null);
            setSelectedCloneAccountList(selectedAccountList);
        }
        setShow(false)
    }



    const columns: DataTableColumn[] = [
        {
            label: "",
            accessor: "certificateAccountDTO.id",
            canSort: false,
            cell: (props: any) => {
                return (
                    <input
                        type="checkbox"
                        onChange={() => {
                            const index = selectedAccountList.findIndex((e) =>
                                !isHoaEditor
                                    ? e.certificateAccountDTO.propertyId === props.row.original.certificateAccountDTO.propertyId
                                    : e.certificateAccountDTO.accountNumber === props.row.original.certificateAccountDTO.accountNumber &&
                                    e.certificateAccountDTO.subdivisionId === props.row.original.certificateAccountDTO.subdivisionId &&
                                    e.certificateAccountDTO.associationId === props.row.original.certificateAccountDTO.associationId
                            );

                            const list = [...selectedAccountList];

                            if (index > -1) {
                                if (list[index].certificateAccountDTO.id !== props.row.original.certificateAccountDTO.id) {
                                    list.push(props.row.original);
                                }
                                list.splice(index, 1);
                            } else {
                                list.push(props.row.original);
                            }

                            setSelectedAccountList(list);
                        }}
                        onClick={() => setDate(props.row.original.certificateAccountDTO.id + Date.now())}
                        checked={selectedAccountList.map(e => e.certificateAccountDTO?.id).includes(props.row.original.certificateAccountDTO?.id)}
                    />
                );
            }
        },
        {
            label: "Order No.", accessor: "customerOrderNumber",
            filterOptions: [
                {
                    filterComponent: <SearchInputWrapper type="text" placeholder="Enter Number..." name="customerOrderNumber" accessor="customerOrderNumber" defaultValue={customerOrderNumber ?? ''} />,
                    overrideFilterLabel: "Order No./TGX ID",
                    overrideFilterAccessor: "customerOrderNumber"
                }
            ]
        },
        {
            label: "State", accessor: "state",
            filterOptions: [{
                filterComponent: <SearchInputWrapper disabled type="text" name="state" accessor="state" defaultValue={state ?? ''} />
            }]
        },
        {
            label: "County", accessor: "countyName",
            filterOptions: [
                {
                    dependentColumns: ["Account No."],
                    filterComponent: SearchSelectWithList(countyData.data, "countyName", "id", "Select County...", false, "countyName")
                }
            ]
        },
        {
            label: "Account No.", accessor: "accountNumber",
            filterOptions: [
                {
                    filterComponent: <SearchInputWrapper type="text" placeholder="Enter Account Number..." className={isCountySelected ? 'disabled_field' : ''} name="certificateAccountDTO.propertyId" accessor="certificateAccountDTO.propertyId" disabled={isCountySelected} />,
                    overrideFilterLabel: "Account Number",
                    overrideFilterAccessor: "accountNumber",
                    onDependencyUpdated: (value: string) => {
                        setIsCountySelected(!(value && value.trim() !== ""));
                    }
                }
            ]
        },
        { label: "Update No.", accessor: "reOrderNumber" }
    ];


    return (
        <Modal
            title={"Clone Accounts"}
            show={show}
            setShow={setShow}
            hoa={isHoaEditor}
            className="w-3/6 bg-text-0 rounded-lg shadow-lg "
            fields={
                <>
                    

                                <DataTable
                                    columns={columns}
                                    actions={{
                                        fetchAction: useClonedAccountsQuery,
                                    }}
                                    defaultSortOptions={{
                                        accessor: "creationDate",
                                        direction: "asc",
                                    }}
                                    defaultFilter={{
                                        pageNumber: 0,
                                        pageSize: 5,
                                        orderId: orderId,
                                        tenant: tenant,
                                        taxCert: !isHoaEditor,
                                        customerOrderNumber: customerOrderNumber == "" || customerOrderNumber == "null" ? null : customerOrderNumber,
                                    }}
                                    defaultFilterFormExpanded={true}
                                    renderOptions={{
                                        skipUserSettingRender: true,
                                        skipFilterButtonRender: true,
                                    }}
                                    appendFilterToUrl={false}
                                    isHoa={isHoaEditor}
                                    classname={isHoaEditor ? "bg-highlight-1 text-[white] border-highlight-1" : "bg-highlight-5 text-[white] mt-3"}
                                />
                        

                        {selectedAccountList.length > 0 && (
                            <div className={isHoaEditor ? "block w-full overflow-x-auto overflow-scroll-touch hoa_table table-responsive border-highlight-1" : "block w-full overflow-x-auto overflow-scroll-touch table-responsive"}>
                                <h3 className="text-2xl font-semibold">Selected Property</h3>
                                <table className="table table-hover table-striped w-full">
                                    <thead className={!isHoaEditor ? `bg-highlight-0 text-text-0 relative text-left` : `bg-highlight-1 text-text-0 relative text-left`}>
                                        <tr>
                                            <th>Order No</th>
                                            <th>County</th>
                                            <th>Account Number</th>
                                            <th>Update No.</th>
                                            <th>As Of</th>
                                        </tr>
                                    </thead>
                                    <tbody className={selectedAccountList.length > 4 ? "table_height" : undefined}>
                                        {selectedAccountList.map((current, index) => (
                                            <tr key={index}>
                                                <td>{current.customerOrderNumber}</td>
                                                <td>{current.countyName}</td>
                                                <td>
                                                    {current.certificateAccountDTO?.propertyId ||
                                                        current.certificateAccountDTO?.accountNumber}
                                                </td>
                                                <td>{current.reOrderNumber}</td>
                                                <td>{formatValueAsDate(current.certificateAccountDTO.asOfDate)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                  

                    <div className="form-group ml-0 flex justify-between">
                        <ButtonTray
                            buttons={[
                                {
                                    buttonProps: {
                                        btnText: "Cancel",
                                        onClick: () => setShow(false),
                                        type: "cancel",
                                        isHoa:isHoaEditor
                                    },
                                    buttonType: "button",
                                },
                                {
                                    buttonProps: {
                                        btnText: "Submit",
                                        onClick: handleSubmit,
                                        type: "submit",
                                        isDisabled: selectedAccountList.length==0,
                                        isHoa:isHoaEditor
                                    },
                                    buttonType: "button",
                                },
                            ]}
                            align="start"
                            gap={2}
                        />

                        {selectedAccountList.length > 0 &&
                            selectedAccountList.some((el) =>
                                isHoaEditor
                                    ? existingProperty.some((p) =>
                                        isDuplicateAccountExist(p, el.certificateAccountDTO)
                                    )
                                    : existingProperty.some(
                                        (p) =>
                                            trimSpace(p.propertyId) ===
                                            trimSpace(el.certificateAccountDTO.propertyId)
                                    )
                            ) && (
                                <div className={"flex gap-2 items-center"}>

                                    <i
                                        className={
                                            isHoaEditor
                                                ? "fa fa-warning fa-2x hoa-fa-icon-color"
                                                : "fa fa-warning fa-2x fa-icon-color"
                                        }
                                    ></i>
                                    <div className="col-6 text-error-1 margin_top pl-0">
                                        <span>Action will overwrite existing accounts</span>
                                    </div>

                                </div>
                            )}
                    </div>
                </>
            }
        />

    );
}
